document.addEventListener('DOMContentLoaded', function () {
  const isCollectionPage = !!document.querySelector('main.collection')

  const mainTabButtons = document.querySelectorAll('.sec01 .js_tab_btn')
  const jumpTabButtons = document.querySelectorAll(
    '.js_museum-guide_jump_tab, .js_facilities_jump_tab',
  )
  const mainTabContents = document.querySelectorAll('.js_tab_content')
  const tabTitles = document.querySelectorAll('.js_tab_title')
  const sec02 = document.querySelector('.museum-guide .sec02, .facilities .sec02')
  const isMuseumGuidePage = !!document.querySelector('main.museum-guide')

  function getHeaderHeight() {
    const header = document.querySelector('header') || document.querySelector('.header')
    return header ? header.offsetHeight : 0
  }

  function scrollToSec02() {
    if (!sec02) return

    const top = sec02.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight()

    window.scrollTo({
      top,
      behavior: 'smooth',
    })
  }

  if (!isCollectionPage && mainTabButtons.length && mainTabContents.length) {
    function activateMainTab(tabName, updateUrl = false, shouldScroll = false) {
      let activeButton = null

      mainTabButtons.forEach((button) => {
        const isCurrent = button.dataset.tab === tabName
        button.classList.toggle('is-current', isCurrent)

        if (isCurrent) {
          activeButton = button
        }
      })

      mainTabContents.forEach((content) => {
        content.classList.toggle('is-current', content.dataset.tabContent === tabName)
      })

      if (activeButton && tabTitles.length) {
        const label = activeButton.querySelector('.tab_btn_label')
        if (label) {
          tabTitles.forEach((title) => {
            title.textContent = label.textContent.trim()
          })
        }
      }

      if (updateUrl) {
        const url = new URL(window.location.href)
        url.searchParams.set('tab', tabName)
        window.history.replaceState({}, '', url)
      }

      if (shouldScroll) {
        scrollToSec02()
      }

      const eventName = isMuseumGuidePage ? 'museum-guideTabChanged' : 'facilitiesTabChanged'

      document.dispatchEvent(
        new CustomEvent(eventName, {
          detail: { tabName },
        }),
      )
    }

    const params = new URLSearchParams(window.location.search)
    const initialTab = params.get('tab')
    const validTabs = Array.from(mainTabButtons).map((button) => button.dataset.tab)

    if (initialTab && validTabs.includes(initialTab)) {
      activateMainTab(initialTab)
    } else if (validTabs.length) {
      activateMainTab(validTabs[0])
    }

    mainTabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        activateMainTab(this.dataset.tab, true, false)
      })
    })

    jumpTabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        activateMainTab(this.dataset.tab, true, true)
      })
    })
  }

  const subTabGroups = document.querySelectorAll('.js_sub_tab')

  subTabGroups.forEach((group) => {
    const subTabButtons = group.querySelectorAll('.js_sub_tab_btn')
    let subTabContents = null

    // 1. about のように .js_sub_tab 内に .tab_contents があるパターン
    const innerTabContents = group.querySelector('.tab_contents')
    if (innerTabContents) {
      subTabContents = innerTabContents.querySelectorAll('.js_sub_tab_content')
    }

    // 2. museum-guide のように .map の次に .sub_tab_contents があるパターン
    if (!subTabContents || !subTabContents.length) {
      const map = group.closest('.map')
      const siblingContents = map ? map.nextElementSibling : null
      if (siblingContents && siblingContents.classList.contains('sub_tab_contents')) {
        subTabContents = siblingContents.querySelectorAll('.js_sub_tab_content')
      }
    }

    // 3. 念のためのフォールバック
    if (!subTabContents || !subTabContents.length) {
      const wrapper = group.parentElement
      if (wrapper) {
        subTabContents = wrapper.querySelectorAll('.js_sub_tab_content')
      }
    }

    if (!subTabButtons.length || !subTabContents || !subTabContents.length) return

    function activateSubTab(tabName) {
      subTabButtons.forEach((button) => {
        button.classList.toggle('is-current', button.dataset.tab === tabName)
      })

      subTabContents.forEach((content) => {
        content.classList.toggle('is-current', content.dataset.tabContent === tabName)
      })
    }

    const initialButton = group.querySelector('.js_sub_tab_btn.is-current') || subTabButtons[0]
    if (initialButton) {
      activateSubTab(initialButton.dataset.tab)
    }

    subTabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        activateSubTab(this.dataset.tab)
      })
    })
  })
})
